import { createGlobalStyle } from 'styled-components';
import { maxWidth } from 'config/constants';

export const MachineDetailsDrawerGlobalStyles = createGlobalStyle`
  .machine-details-drawer {
    .ant-drawer-body {
      position: relative;
    }

    .schedule-create-modal-root {
      position: absolute;
      inset: 0;
      z-index: 10;
      pointer-events: none;

      .ant-modal-wrap {
        position: absolute;
        pointer-events: auto;

        .ant-modal {
          margin: 0;
        }
      }
    }
  }

  .ant-drawer-content-wrapper {
    ${maxWidth.l} {
      width: 90vw !important;
    }
  }
`;
